import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import "../CitationList.css"
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    height: 165,
    width: 170
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function CustomizedMenus({ handlestyle }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [dropdownValue, setdropdownValue] = React.useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDropdown = (value) => {
    console.log(value)
    setdropdownValue(value)
    handlestyle(value)
  }
  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        style={{ backgroundColor: "#1976d2", color: "white" }}
        onClick={handleClick}
      >
        CHANGE STYLE{anchorEl === null ? (<ArrowDropDownIcon fontSize="large" />) : (<ArrowDropUpIcon fontSize="large" />)}

      </Button>
      <StyledMenu

        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}


      >
        <div className="drop">
          <StyledMenuItem onClick={() => handleDropdown("mla8")}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="MLA8" />
          </StyledMenuItem>
          <StyledMenuItem onClick={() => handleDropdown("mla7")}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="MLA7" />
          </StyledMenuItem>
          <StyledMenuItem onClick={() => handleDropdown("apa")}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="APA" />
          </StyledMenuItem>
          <StyledMenuItem onClick={() => handleDropdown("chicago")}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Chicago" />
          </StyledMenuItem>
        </div>
      </StyledMenu>
    </div>
  );
}
